import React from "react";
import { RatingStar } from "../../../../custom/RatingStar";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DateTimeToNormalDate } from "../../../../custom/DateTimeToNormalDate";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import TextWrap from "../../../../custom/TextWrap";
import { useNavigate } from "react-router";

const ProductCards = ({ reviewData, dummy_user, loadMoreData, hasMore }) => {
  const navigate = useNavigate();
  const handleNavigateProductReview = (item) => {
    navigate(`/app/product-details/${item?.product_detail?._id}`);
  };
  // console.log("total length", hasMore);
  // console.log("reviewdata", reviewData?.length);
  return (
    <div>
      {reviewData?.map((item) => {
        const halfStar = RatingStar(item?.rating) > 0.5 ? 1 : 0;
        const oneStar = 5 - item?.rating - halfStar;
        return (
          <div className="flex gap-4 p-6 border-b border-gray-300">
            <div className="w-[25%]">
              <LazyLoadImage
                src={item?.images[0] || dummy_user}
                alt="user avatar"
                loading="lazy"
                effect="blur"
                wrapperProps={{
                  style: { transitionDelay: "1s" },
                }}
                className="h-20 w-20 shadow-lg"
              />
            </div>

            <div className="w-[100%]">
              <div className="flex justify-between items-center">
                <div>
                  <p
                    className=" font-bold text-md text-gray-600 cursor-pointer"
                    onClick={() => handleNavigateProductReview(item)}
                  >
                    {item?.product_detail?.name}
                  </p>
                  <p className="capitalize text-sm text-[var(--color--2)] ">
                    {item?.user?.first_name} {item?.user?.last_name}
                  </p>
                  <p>{DateTimeToNormalDate(item?.updatedAt)}</p>
                </div>
              </div>
              <p className="capitalize text-sm mt-2 text-gray-700">
                {TextWrap(item?.review, 150)}
              </p>
              <div className="flex items-center mt-4">
                <div className="flex">
                  {[...Array(item?.rating)].map((_, idx) => {
                    return (
                      <FaStar
                        key={idx}
                        className="text-[var(--color--2)] text-xl"
                      />
                    );
                  })}
                  {RatingStar(item?.rating) > 0.5 ? (
                    <FaStarHalfAlt className="text-[var(--color--2)] text-xl" />
                  ) : (
                    [...Array(oneStar)]?.map((_, idx) => {
                      return (
                        <FaRegStar
                          key={idx}
                          className="text-[var(--color--2)] text-xl"
                        />
                      );
                    })
                  )}
                </div>
                <p className="text-base text-gray-600 ml-2">({item?.rating})</p>
              </div>
            </div>
          </div>
        );
      })}
      {hasMore > reviewData?.length ? (
        <button
          onClick={loadMoreData}
          className="shadow-md bg-white border px-2 py-1 mt-3 w-full rounded-md  "
        >
          Load more
        </button>
      ) : null}
    </div>
  );
};

export default ProductCards;
